<template>
 <div class="d-flex align-center justify-center" style="height: 100vh">
        <v-sheet width="400" class="mx-auto">
            <v-form fast-fail @submit.prevent="logIn">
                <v-text-field variant="outlined" v-model="username" label="User Name" name="UserName"></v-text-field>

                <v-text-field variant="outlined" v-model="password" label="password" name="Password"></v-text-field>

                <v-btn type="submit" color="attention" block class="mt-2">Sign in as {{ username }}</v-btn>

              </v-form>
            <div class="mt-2">
              <br>
              <v-btn type="submit" color="regular" variant="outlined" block class="mt-2" @click="$router.push('/help')">Forgot Password?</v-btn>
<br>

              <v-btn type="submit" color="regularlight" variant="outlined" block class="mt-2" @click="$router.push('/about')">Don't have an account?</v-btn>
            </div>
        </v-sheet>
    </div>
  </template>
  <script>
  import axios from 'axios';

    export default {
      data(){ 
        return {

      username: '',
      password: '',

      message: '',

      }
    },
  
      methods: {

logIn () {
  let username = this.username;
  let password = this.password;

  axios.post(this.$store.state.mainurl+'/users/login', {username: username, password: password}).then((response) => {
      if (response.status == 200) {
      this.$router.push('/');
   //   this.$router.go(-2);
  //  console.log(this.document.cookie);
  //  let dc = "abra";
  //  console.log(dc);
   this.$store.commit('getCookies');
  
          } 
      else {
//  console.log(response);
      this.$router.push('/contacts');
      }
  })
  .catch(error => console.log(error), this.message = "Error!!!!!");
},
//     if (response.status == "ok") {
/*        userSettings(lsection){
            this.login = login;
            this.lsection = lsection;
            this.gotousersection = $router.push('/lichens');
            return gotousersection;
            */
            // чет я туплю - где и как активировать userSettings и как login передать дальше?
            // lsection - получить из таблицы Юзеры (по имени юзера).
            //надо их засунуть в vuex, чтобы не пробрасывать потом по всем компонентам
 //       }
      },
    }
  </script>